import { service } from '@ember/service';
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class NavbarLinkComponent extends Component {
  @service router;

  get currentRoute() {
    return this.args.currentRoute ?? this.router.currentRoute;
  }

  @action
  isActive() {
    if (this.args.model)
      return (
        this.currentRoute?.name?.includes(this.args.key) &&
        this.currentRoute?.parent?.attributes?.id === this.args.model
      );
    return this.args.exact
      ? this.currentRoute?.name === this.args.key
      : this.currentRoute?.name?.includes(this.args.key);
  }

  @action
  onClick() {
    this.args.onClick?.();
  }
}
